import { render, staticRenderFns } from "./ColdWeatherConcList.vue?vue&type=template&id=882091b2"
import script from "./ColdWeatherConcList.vue?vue&type=script&lang=js"
export * from "./ColdWeatherConcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports